<template>
<div class="product">
  <Header/>
  <div class="container main">
    <div class="beishu"></div>
    <Parameter/>
    <Details/>
    <Step/>
    <div class="btn"><a href="javascript:;">返回</a></div>
  </div>
  <Footer/>
</div>
</template>

<script>
import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
import Parameter from "@/components/PC/Details/Parameter.vue";
import Details from "@/components/PC/Details/Details.vue";
import Step from "@/components/PC/Details/Step.vue";

export default {
  name: "Order",
  data() {
    return {
      active: 2,
      ordersn:{}
    };
  },
  components: {
    Header,
    Footer,
    Parameter,
    Details,
    Step
  },
  mounted: function() {
    
  },
  computed: {
  },
  methods: {
  },
  created() {
  }
};
</script>
<style>
.beishu{background: url(../../../assets/image/beishu.png) center center no-repeat;background-size:1226px 250px;width: 1226px;height: 250px;margin-top:20px}
.product .btn{text-align: center;margin:100px auto 0;}
.product .btn a{display: inline-block;width: 200px;height: 48px;line-height: 48px;text-align: center;margin: 0 auto;background: #f9415d;color: #fff;box-shadow: #efefef 0 0 5px;border-radius: 50px;}
</style>
